import styled from 'styled-components';

export default styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  font-weight: bold;
  color: #263238;
  margin: 10px;
`;
